export default "__VITE_ASSET__1f5d4845__"